import {
  GetProspectsFromDIRQueryParams,
  SearchProspectsFromDIRResponse,
} from '../../../../../../types/api/endpoints/prospect/prospect.types';
import { PROSPECT_ENDPOINTS } from '../../../../../../utils/api/endpoints/prospectEndpoints';

const SEARCH_PREFIX = '[searchProspectFromDIRQuery]';

export const SEARCH_PROSPECT_FROM_DIR_QUERY_KEY = 'SEARCH_PROSPECT_FROM_DIR';

export const searchProspectFromDIRQuery = async (
  search: string,
  params: GetProspectsFromDIRQueryParams
) => {
  console.log(SEARCH_PREFIX, `Fetching search prospects...`);
  const response = await PROSPECT_ENDPOINTS.searchFromDIR(search, params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(SEARCH_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(SEARCH_PREFIX, `Fetched search prospects.`);
  return json as SearchProspectsFromDIRResponse;
};
